module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAsBAMAAADP8RbnAAAAElBMVEUAAAD44eH44+P45OT34uL44uLEYX+fAAAABXRSTlMA8r1MheKcwngAAABCSURBVDjLY2AwEg3FBQKVGRhYQvEBBwZTvPLBDKp45YMYRPHKBzKE4gej8qPyo/Kj8rgAofKFUPlEqHwjVD4SKl8BOnHAcPqLt7wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pink_icon.png
// module id = zzng
// module chunks = 167